module.exports = __webpack_public_path__ + "img/activity-title.cedd3cba.png";